module.exports = __webpack_public_path__ + "static/about-three-737e5bf428e35091cbb6138564d194c0.webp";